module.exports = __webpack_public_path__ + "static/media/elixir-restaurant-img-1.5d8b5242.jpg";